import { ReaderRow } from '../../../generated/api/chat-room'
import { formatRelative } from '../../../helpers/date'

export const readerSubtitle = (
  row: Pick<ReaderRow, 'readAt' | 'unitLabel'>,
  formatReadAt: (readAt: number) => string = formatRelative
): string =>
  [row.unitLabel, formatReadAt(row.readAt)]
    .filter((part): part is string => !!part)
    .join(' · ')
